function ExcelTemplateFileGeneration() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Report.Template.Creation visual. <br/>
    /// <br/>
    /// it fills the form items and sends them to the webserver for saving
    /// Author: MWI<br />
    /// Date: 22.05.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// ***********************************************************************<br />
    /// *** v1.0.1 - 04.12.2017                                               *<br />
    /// ***********************************************************************<br />
    /// * - fixed bug with erraneous validation of txtfile                    *<br />
    /// * - changed some default values of inputs                             *<br />
    /// ***********************************************************************<br />
    /// *** v1.0.0 - 22.05.2017                                               *<br />
    /// ***********************************************************************<br />
    /// * - basic functionality                                               *<br />
    /// ***********************************************************************<br />
    /// </summary>
    this.ENUM_FORMAT_TYPE = Object.freeze({ LANDSCAPE: 1, PORTRAIT: 2,  PORTRAITSIMPLE: 3 });
}
ExcelTemplateFileGeneration.prototype = new window.vcTemplate();

ExcelTemplateFileGeneration.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler 
    /// </summary>
    var me = this;
    var tmpFormat;
    var downloadPath;
    try {
        if (me.error) {
            return;
        }
        me.showInfo("", "", false);
        me.visual.find(".edit").off("click").on("click", function () {
            me.uploadFile();
            return true;
        });
        
       // tmpFormat = me.format;
        me.loadFileViewer(me.mediaid);
      
        //me.visual.find("#ddl-select-format").val(me.format);

        //me.visual.find("#ddl-select-format").off("change").on("change",
        //    function () {
        //        me.format = parseInt($(this).val());
            
        //    });
      

        me.initClickHandler();
    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.init", ex);
    }
};
//ExcelTemplateFileGeneration.prototype.setFormat = function(format) {
//    var me = this;
//    try {
//        me.hasUnsavedFormat = true;
//        me.format = format;
//    } catch (ex) {
//        me.writeError("ExcelTemplateFileGeneration.setFormat", ex);
//    }

//};
ExcelTemplateFileGeneration.prototype.uploadFile = function() {
    var me = this;
    try {

        window.VisualCoreService.getVisualContentByName("WIDGET_GALLERY_UPLOAD",
            "uploadDialog",
            window.getCurrentTimestamp(),
            400,
            592,
            JSON.stringify({ mediaCategory: "REPTEMPLATE", editable: true }),
            JSON.stringify({
                'mediaId': me.mediaid,
                "btnBackToItem": "WIDGET_REPORT_TEMPLATE_GENERATION",
                "btnBackToItemDiv": "#" + me.visual[0].id,
                "rrid": me.rrid
            }),
            2,
            function(result) {
                me.visual.find("#div-rep-template-options, #report-template-files").hide();
                me.visual.find("#report-uploader").html(result);
            });
    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.uploadFile", ex);
    }
};

ExcelTemplateFileGeneration.prototype.doEvent = function(event) {
    /// <summary>
    /// calls the button back function when a project got deleted
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
        switch (event.msg) {
        case "GALLERY_CHANGED":
                if (event.values.mediaId !== "-1") {
                   
                 me.saveCustomTemplateWS(event.values.mediaId);
                } else {
                  
                me.saveCustomTemplateWS(-1);

            }
            break;
        }
        return true;
    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.doEvent", ex);
        return false;
    }
};

ExcelTemplateFileGeneration.prototype.prepareTemplate = function () {
    /// <summary>
    /// This calls the dialog for validation and calls teh webservice<br/>
    /// </summary> 
    var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
        if (me.mediaid !== -1) {
            me.dialog = $("<div>")
                .html("<div class='note'>" + me.resources.reallyOverwrite + "</div>");
            me.dialog.attr("id", "divOverwriteTemplate");
            me.dialog.dialog({
                title: me.resources.attention,
                width: 450,
                height: 140,
                modal: true,
                resizable: false,
                autoOpen: false,
                dialogClass: "saveDialog",
                buttons: [
                    {
                        text: me.resources.yes,
                        click: function () {
                            me.prepareTemplateWS();
                            me.dialog.dialog("close");
                            return true;
                        }
                    },
                    {
                        text: me.resources.no,
                        click: function () {
                            me.dialog.dialog("close");
                            return true;
                        }
                    }
                ],
                close: function () {
                    $(this).dialog("destroy");
                }
            });
            me.dialog.dialog("open");
        } else {
            me.prepareTemplateWS();
        }
        return true;
    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.prepareTemplate", ex); return false;
    }
};
ExcelTemplateFileGeneration.prototype.loadFileViewer = function (id) {
    /// <summary>
    /// This function inits the thhe fileviewer object <br/>
    /// </summary>
    var me = this;
    try {
        var media = {
            mediaID: id,
            height: 400,
            width: 592,
            pos: 'right',
            show: true
        };
       
      
        if (id !== -1) {
            window.VisualCoreService.getVisualContentByName("VISUAL_FILEVIEWER", "viewer", window.getCurrentTimestamp(), 400, 592, JSON.stringify(media), "", 1, function (result) {
                me.visual.find("#div-created").html(result);
            });
        } else {
            me.visual.find(".eI").html("<div class='error'><div>" + me.resources.noTemplateGenerated + "</div></div>");
            me.visual.find("#div-created").html(
                "<div class='note btn-create-note vc-grid-3col'>" + me.resources.uploadFileInfo + "</div><div id='btn-upload-prepared-template' class='btn-file-action vc-grid-3col'><i class='fa fa-upload fa-3x'></i><br>" + me.resources.uploadFile + "</span></div><div class='note btn-create-note vc-grid-3col'>" + me.resources.generateNewTemplateInfo + "</div><div id='btn-create-template' class='btn-file-action vc-grid-3col'><i class='fa fa-book fa-3x'></i><br>" + me.resources.generateNewTemplate + "</span></div>");
            me.visual.find(".btn-file-action").button();
            me.visual.find("#btn-create-template").off("click").on("click",
                function () {

                    me.prepareTemplateWS();
                });
            me.visual.find("#btn-upload-prepared-template").off("click").on("click",
                function () {
                    me.visual.find(".eI").html(me.resources.fileHeader);

                    me.uploadFile();

                });
        }
     
    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.loadFileviewer", ex);
    }
};
ExcelTemplateFileGeneration.prototype.sendReportValidState = function () {
    var me = this;
    try {
        window._VCMQ.produce(me.visual, me.vcgid, "REP_CONFIG_VALID", { "valid": true, "step": 3 });
        window._VCMQ.produce(me.visual, me.vcgid, "REP_CONFIG_VALID", { "valid": false, "step": 4 });

    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.sendReportValidState", ex);
    }
};
ExcelTemplateFileGeneration.prototype.prepareTemplateWS = function () {
    /// <summary>
    /// This function calls the webservice
    /// </summary>
    var me = this;
    try {

        me.visual.find(".eI").html(me.resources.fileHeader);

        me.visual.find("#div-created").html(me.vcC.getLoadingIcon());
        me.visual.find(".edit").toggleClass("disable", true);
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", JSON.stringify({ "updateType": 0, "rrid": me.rrid, "mediaid": -1, "format": me.format }), me.deviceType, me.langid, "", function (result) {
            if (result.hasError === false) {
                me.mediaid = result.mediaId;
                me.visual.find(".edit").toggleClass("disable", false);
                me.sendReportValidState();
                me.loadFileViewer(parseInt(result.mediaId, 10));
                me.visual.find(".edit").off("click").on("click",
                    function() {
                        me.uploadFile();
                        return true;
                    });

                // 
               ////// me.downloadPath = result.mediaPath;
                
                me.visual.find("#report-template-download").removeAttr("href");

                me.visual.find("#report-template-download").off("click").on("click",
                    function() {
                    
                        downloadMediaDataUrl(me.visual.find(".divMediaUrl").data("url"));
                        //e.stopPropagation();
                    });
            } else {
                me.showInfo(result.returnHTML, "", true);
            }
        });
    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.prepareTemplateWS", ex);

    }
};


ExcelTemplateFileGeneration.prototype.saveCustomTemplateWS = function (uploadedmediaid) {
    /// <summary>
    /// This function calls the webservice
    /// </summary>
    var me = this;
    try {
        me.visual.find("#div-created").html(me.vcC.getLoadingIcon());
        me.visual.find(".edit").toggleClass("disable", true);
       //console.info("uploadedid: " + uploadedmediaid);


        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", JSON.stringify(
            { "updateType": 1, "rrid": me.rrid, "mediaid": uploadedmediaid, "format": me.format }), me.deviceType, me.langid, "", function (result) {
                me.visual.find(".edit").toggleClass("disable", false);
                me.sendReportValidState();
                me.mediaid = result.mediaId;
                me.loadFileViewer(parseInt(result.mediaId, 10));
                me.visual.find(".edit").off("click").on("click", function () {
                    me.uploadFile();
                    return true;
                });
                me.visual.find("#report-template-download").attr("download", result.mediaName);

                me.downloadPath = result.mediaPath;
            //alert("here1");
            //me.visual.find("#report-template-download").off("click").on("click",
            //    function (e) {

            //        downloadMediaDataUrl(me.visual.find(".divMediaUrl").data("url"));
            //        e.stopPropagation();
            //    });
                me.visual.find("#report-uploader").html("");
                me.visual.find("#div-rep-template-options, #report-template-files").show();


            });
    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.saveCustomTemplateWS", ex);

    }
};
ExcelTemplateFileGeneration.prototype.initClickHandler = function () {
    /// <summary>
    /// Initializes all clickhandlers once 
    /// </summary>
    var me = this;
    var bRet = true;
    try {
        if (me.error) {
            bRet = false;
        } else {
            me.visual.find("#btnCreate").button().off("click").on("click", function () { me.prepareTemplate(); });
        }
        
        //// 
       // me.visual.find("#report-template-download").removeAttr("href");

        //me.visual.find("report-template-files").off("click", "#report-template-download").on("click", "#report-template-download",
        //    function () {
        //        alert("here");
        //        downloadMediaDataUrl(me.visual.find(".divMediaUrl").data("url"));
        //        e.stopPropagation();
        //    });

    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.initClickHandler", ex); bRet = false;
    }
    return bRet;
};

ExcelTemplateFileGeneration.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out the fieldsets resp. the complete div on error
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find(".galleryList").hide();
        }
        return true;
    } catch (ex) {
        me.writeError("ExcelTemplateFileGeneration.specificInfoHandling", ex);
        return false;
    }
};


